import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IDepartmentList } from '@umu/umu-types';

/*
    type类型
    1-负责的部门（部门负责人身份）
    2-管理的部门
    3-负责的部门+管理的部门
*/
export interface ISugDepartListParam {
    keywords: string;
    type?: number;
}
export interface ISugDepartListInfo {
    department_id: string;
    department_name: string;
    parent_path: IDepartmentList[];
}
export const getSugDepartment = (data: ISugDepartListParam): Promise<ISugDepartListInfo[]> => {
    return fetchData(Api.GET_DEPARTMENT_SUG, data).then((res: IResponse<ISugDepartListInfo[]>) => {
        return res.data;
    });
};
